import axios from './axios';
import API_URL from './ApiUrl';

export const login = async (params) => {
    return await axios
        .post(`${API_URL.LOGIN_URL}`, params)
        .then((data) => data.data)
        .catch((error) => {
            throw error.response;
        });
};

export const forgotPassword = async (params) => {
    return await axios
        .post(`${API_URL.FORGOT_PASSWORD_URL}`, params)
        .then((data) => data.data)
        .catch((error) => {
            throw error.response;
        });
};

export const changePassword = async (params) => {
    return await axios
        .post(`${API_URL.CHANGE_PASSWORD_URL}`, params)
        .then((data) => data.data)
        .catch((error) => {
            throw error.response;
        });
};

export const resetPassword = async (params) => {
    return await axios
        .post(`${API_URL.RESET_PASSWORD_URL}`, params)
        .then((data) => data.data)
        .catch((error) => {
            throw error.response;
        });
};

export const fetchMe = async () => {
    return await axios
        .get(`${API_URL.FETCH_ME_URL}`)
        .then((data) => data.data)
        .catch((error) => {
            throw error.response;
        });
};

export const updateProfile = async (params) => {
    return await axios
        .patch(`${API_URL.ADMIN_URL}`, params)
        .then((data) => data.data)
        .catch((error) => {
            throw error.response;
        });
};

export const reportCourts = async (params) => {
    return await axios
        .post(`${API_URL.REPORT_COURTS}`, params)
        .then((data) => data.data)
        .catch((error) => {
            throw error.response;
        });
};

export const getDashboardData = async () => {
    return await axios
        .get(`${API_URL.GET_DASHBOARDDATA_URL}`)
        .then((data) => data.data)
        .catch((error) => {
            throw error.response;
        });
};

export const createClub = async (params) => {
    return await axios
        .post(`${API_URL.CLUB_URL}`, params)
        .then((data) => data.data)
        .catch((error) => {
            throw error.response;
        });
};

export const updateClub = async (params) => {
    const { _id, ...payload } = params;
    return await axios
        .patch(`${API_URL.CLUB_URL}/${_id}`, payload)
        .then((data) => data.data)
        .catch((error) => {
            throw error.response;
        });
};

export const retrieveClubs = async (params) => {
    return await axios
        .get(`${API_URL.ADMIN_CLUB_URL}`, { params })
        .then((data) => data.data)
        .catch((error) => {
            throw error.response;
        });
};

export const readClub = async (params) => {
    return await axios
        .get(`${API_URL.ADMIN_CLUB_URL}/${params._id}`)
        .then((data) => data.data)
        .catch((error) => {
            throw error.response;
        });
};

export const blockClub = async (params) => {
    return await axios
        .post(`${API_URL.ADMIN_CLUB_URL}/${params._id}/block`)
        .then((data) => data.data)
        .catch((error) => {
            throw error.response;
        });
};

export const activeClub = async (params) => {
    return await axios
        .post(`${API_URL.ADMIN_CLUB_URL}/${params._id}/active`)
        .then((data) => data.data)
        .catch((error) => {
            throw error.response;
        });
};

export const acceptClubRsService = async (params) => {
    return await axios
        .post(`${API_URL.ADMIN_CLUB_URL}/${params._id}/accept-rsservice`)
        .then((data) => data.data)
        .catch((error) => {
            throw error.response;
        });
};

export const rejectClubRsService = async (params) => {
    const { _id, ...payload } = params;
    return await axios
        .post(`${API_URL.ADMIN_CLUB_URL}/${_id}/reject-rsservice`, payload)
        .then((data) => data.data)
        .catch((error) => {
            throw error.response;
        });
};

export const controlClubFeature = async (params) => {
    const { _id, ...payload } = params;
    return await axios
        .post(`${API_URL.ADMIN_CLUB_URL}/${_id}/update-feature`, payload)
        .then((data) => data.data)
        .catch((error) => {
            throw error.response;
        });
};

export const resetClubPassword = async (params) => {
    const { _id, ...payload } = params;
    return await axios
        .post(`${API_URL.ADMIN_CLUB_URL}/${_id}/reset-password`, payload)
        .then((data) => data.data)
        .catch((error) => {
            throw error.response;
        });
};

export const searchReports = async () => {
    return await axios
        .get(`${API_URL.SEARCH_REPORTS_URL}`)
        .then((data) => data.data)
        .catch((error) => {
            throw error.response;
        });
};

export const getReport = async (params) => {
    return await axios
        .get(`${API_URL.GET_REPORT_URL}/${params._id}`)
        .then((data) => data.data)
        .catch((error) => {
            throw error.response;
        });
};

export const resolveReport = async (params) => {
    return await axios
        .post(`${API_URL.RESOLVE_REPORT_URL}`, params)
        .then((data) => data.data)
        .catch((error) => {
            throw error.response;
        });
};

export const getSystemSettings = async (params) => {
    return await axios
        .get(`${API_URL.SYSMANAGE_URL}`, { params })
        .then((data) => {
            return data.data;
        })
        .catch((error) => {
            throw error.response;
        });
};

export const updateSystemSettings = async (params) => {
    return await axios
        .patch(`${API_URL.SYSMANAGE_URL}`, params)
        .then((data) => data.data)
        .catch((error) => {
            throw error.response;
        });
};

export const getDBBackupFiles = async (params) => {
    return await axios
        .get(`${API_URL.GET_DBBACKUPFILES_URL}`, { params })
        .then((data) => data.data)
        .catch((error) => {
            throw error.response;
        });
};

export const restoreDatabase = async (params) => {
    return await axios
        .post(`${API_URL.RESTORE_DB_URL}`, params)
        .then((data) => data.data)
        .catch((error) => {
            throw error.response;
        });
};

export const backupDatabase = async (params) => {
    return await axios
        .post(`${API_URL.BACKUP_DB_URL}`, params)
        .then((data) => data.data)
        .catch((error) => {
            throw error.response;
        });
};

export const downloadBackupFile = async (params) => {
    return await axios
        .get(`${API_URL.DOWNLOAD_BACKUPFILE_URL}`, { responseType: 'blob', params: params })
        .then((data) => data.data)
        .catch((error) => {
            throw error.response;
        });
};

export const uploadBackupFile = async (params) => {
    const headers = {
        'content-type': 'multipart/form-data',
    };
    const formData = new FormData();
    formData.set('file', params.file);
    return await axios
        .post(`${API_URL.UPLOAD_BACKUPFILE_URL}`, formData, { headers })
        .then((data) => data.data)
        .catch((error) => {
            throw error.response;
        });
};

/*** members */
export const retrieveMembers = async (params) => {
    return axios
        .get(`${API_URL.RETRIEVE_MEMBER_URL}`, { params })
        .then((data) => data.data)
        .catch((error) => {
            throw error.response;
        });
};

export const createMember = async (params) => {
    return await axios
        .post(`${API_URL.CREATE_MEMBER_URL}`, params)
        .then((data) => data.data)
        .catch((error) => {
            throw error.response;
        });
};

export const readMember = async (params) => {
    return await axios
        .get(`${API_URL.READ_MEMBER_URL}/${params._id}`)
        .then((data) => data.data)
        .catch((error) => {
            throw error.response;
        });
};

export const updateMember = async (params) => {
    return await axios
        .post(`${API_URL.UPDATE_MEMBER_URL}`, params)
        .then((data) => data.data)
        .catch((error) => {
            throw error.response;
        });
};

/** Invoices */
export const createInvoice = async (params) => {
    return await axios
        .post(`${API_URL.INVOICE_URL}`, params)
        .then((data) => data.data)
        .catch((error) => {
            throw error.response;
        });
};

export const updateInvoice = async (params) => {
    return await axios
        .patch(`${API_URL.INVOICE_URL}`, params)
        .then((data) => data.data)
        .catch((error) => {
            throw error.response;
        });
};

export const payInvoice = async (params) => {
    return await axios
        .post(`${API_URL.INVOICE_URL}/pay`, params)
        .then((data) => data.data)
        .catch((error) => {
            throw error.response;
        });
};

export const retrieveInvoices = async (params) => {
    return await axios
        .get(`${API_URL.INVOICE_URL}`, { params })
        .then((data) => data.data)
        .catch((error) => {
            throw error.response;
        });
};

export const readInvoice = async (params) => {
    return await axios
        .get(`${API_URL.INVOICE_URL}/${params._id}`)
        .then((data) => data.data)
        .catch((error) => {
            throw error.response;
        });
};

export const deleteInvoice = async (params) => {
    return await axios
        .delete(`${API_URL.INVOICE_URL}`, { params })
        .then((data) => data.data)
        .catch((error) => {
            throw error.response;
        });
};

/** Cmty events */
export const retrieveCmtyEvents = async (params) => {
    return await axios
        .get(`${API_URL.CMTY_EVENT_URL}`, { params })
        .then((data) => data.data)
        .catch((error) => {
            throw error.response;
        });
};

/** Club Payment fee setting */
export const readClubPaymentFeeSetting = async (params) => {
    return await axios
        .get(`${API_URL.PAYMENT_FEESETTING_URL}`, { params })
        .then((data) => data.data)
        .catch((error) => {
            throw error.response;
        });
};
export const updateClubPaymentFeeSetting = async (params) => {
    return await axios
        .post(`${API_URL.PAYMENT_FEESETTING_URL}`, params)
        .then((data) => data.data)
        .catch((error) => {
            throw error.response;
        });
};

export const fileUpload = async (params) => {
    const formData = new FormData();
    formData.append('file', params.file);
    formData.append('type', params.type);
    return await axios
        .post(`${API_URL.UPLOAD_FILE_URL}`, formData)
        .then((data) => data.data)
        .catch((error) => {
            throw error.response;
        });
};

export const registerDeveloper = async (params) => {
    return await axios
        .post(`${API_URL.DEVELOPER_URL}`, params)
        .then((data) => data.data)
        .catch((error) => {
            throw error.response;
        });
};

export const retrieveDevelopers = async (params) => {
    return await axios
        .get(`${API_URL.DEVELOPER_URL}`, { params })
        .then((data) => data.data)
        .catch((error) => {
            throw error.response;
        });
};

export const deleteDeveloper = async (params) => {
    return await axios
        .delete(`${API_URL.DEVELOPER_URL}`, { params })
        .then((data) => data.data)
        .catch((error) => {
            throw error.response;
        });
};

export const searchClubEvents = async (params) => {
    return await axios
        .post(`${API_URL.SEARCH_CLUBEVENT_URL}`, params)
        .then((data) => data.data)
        .catch((error) => {
            throw error.response;
        });
};

export const createPartner = async (params) => {
    return await axios
        .post(`${API_URL.PARTNER_URL}`, params)
        .then((data) => data.data)
        .catch((error) => {
            throw error.response;
        });
};

export const updatePartner = async (params) => {
    const { _id, ...payload } = params;
    return await axios
        .patch(`${API_URL.PARTNER_URL}/${_id}`, payload)
        .then((data) => data.data)
        .catch((error) => {
            throw error.response;
        });
};

export const resetPartnerPwd = async (params) => {
    const { _id, ...payload } = params;
    return await axios
        .post(`${API_URL.ADMIN_PARTNER_URL}/${_id}/reset-password`, payload)
        .then((data) => data.data)
        .catch((error) => {
            throw error.response;
        });
};

export const retrievePartners = async (params) => {
    return await axios
        .get(`${API_URL.PARTNER_URL}`, { params })
        .then((data) => data.data)
        .catch((error) => {
            throw error.response;
        });
};

export const readPartner = async (params) => {
    return await axios
        .get(`${API_URL.PARTNER_URL}/${params._id}`)
        .then((data) => data.data)
        .catch((error) => {
            throw error.response;
        });
};

export const blockPartner = async (params) => {
    return await axios
        .post(`${API_URL.PARTNER_URL}/${params._id}/block`, params)
        .then((data) => data.data)
        .catch((error) => {
            throw error.response;
        });
};

export const activePartner = async (params) => {
    return await axios
        .post(`${API_URL.PARTNER_URL}/${params._id}/active`, params)
        .then((data) => data.data)
        .catch((error) => {
            throw error.response;
        });
};
